import axios from "axios";

// export const baseUrl=`http://localhost:7090/`;
export const baseUrl=`/`;
// export const baseUrl = `https://bd-d2g.rashigames.com/`;

export const getGamesApi = async () => {
    const response = await axios.get(`${baseUrl}api/v1/games`);
    return response;
}

export const printLogsApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/print-logs`, data);
    return response;
}

export const checkSubscriptionApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/subcription-check-api`, data);
    return response;
}

export const deactivateApi = async (data) => {
    const response = await axios.post(`https://subscribe-d2g.rashigames.com/api/v1/deactivate`, data);
    return response;
}

export const subscriptionLogsApi = async (data) => {
    const response = await axios.post(`https://subscribe-d2g.rashigames.com/api/v1/logs`, data);
    return response;
}

export const checkDeactivateCallbackApi = async (data) => {
    const response = await axios.post(`https://subscribe-d2g.rashigames.com/api/v1/deactivate-status`, data);
    return response;
}